(ns frontend.ui.component.lp-portal.report.body.private-equity.fund.credit.pdf.view
  (:require
   [frontend.ui.component.lp-portal.card.pdf.view :as card]
   [frontend.ui.component.lp-portal.column.pdf.view :as column]
   [frontend.ui.component.lp-portal.page.pdf.view :as page]
   [frontend.ui.component.lp-portal.table.pdf.view :as table]
   [frontend.ui.component.lp-portal.text-content.pdf.view :as text-content]
   [frontend.ui.component.lp-portal.report.body.private-equity.pdf.view.details-and-figures :as
    pe-view-details-and-figures]
   [frontend.ui.component.lp-portal.report.body.private-equity.pdf.view.esg :as pe-view-esg]
   [frontend.ui.component.lp-portal.report.body.private-equity.pdf.view.investors :as
    pe-view-investors]
   [frontend.ui.component.lp-portal.report.body.private-equity.pdf.view.overview :as
    pe-view-overview]
   [frontend.ui.component.lp-portal.report.body.private-equity.pdf.view.tearsheet :as
    pe-view-tearsheet]
   [frontend.ui.style.theme.core :as theme]))

(defn capital-account-since-inception-pages
  [report-data]
  (table/dynamic-table-pages
   {:fund-name (:fund-name report-data) :page-title "Capital account" :toc-item true}
   "Capital account since inception, €"
   (->> report-data
        :capital-account-since-inception)
   {:skip-title-cell? true
    :odd-color        (theme/color [:pdf :table :odd-color])
    :even-color       (theme/color [:pdf :table :even-color])
    :heading-color    (theme/color [:pdf :table
                                    :heading-color])}))

(defn capital-account-year-to-date-pages
  [report-data]
  (table/dynamic-table-pages {:fund-name (:fund-name report-data) :page-title "Capital account"}
                             "Capital account year to date, €"
                             (->> report-data
                                  :capital-account-year-to-date)
                             {:skip-title-cell? true
                              :odd-color        (theme/color [:pdf :table :odd-color])
                              :even-color       (theme/color [:pdf :table :even-color])
                              :heading-color    (theme/color [:pdf :table
                                                              :heading-color])}))

(defn fees-and-carried-interest-pages
  [report-data]
  (table/dynamic-table-pages {:fund-name (:fund-name report-data) :page-title "Fees" :toc-item true}
                             "Fees and carried interest, €"
                             (->> report-data
                                  :fees-and-carried-interest)
                             {:skip-title-cell? true
                              :odd-color        (theme/color [:pdf :table :odd-color])
                              :even-color       (theme/color [:pdf :table :even-color])
                              :heading-color    (theme/color [:pdf :table
                                                              :heading-color])}))

(defn credit-pages
  [report-data]
  (concat
   [(page/toc-page {:cover-image :front-page-image
                    :report-data report-data})]
   ;; TODO: The Credit Excel's tearsheet sheet contains less data than Buyout Excels'. Is this intentional? If so, how does it affect the layout of the pdf?
   [(pe-view-tearsheet/tearsheet-page report-data)]
   (pe-view-overview/overview-pages report-data)
   #_(pe-view-esg/esg-pages report-data)
   (pe-view-details-and-figures/details-and-figures-pages report-data)
   (pe-view-investors/investors-pages report-data)
   (capital-account-since-inception-pages report-data)
   (capital-account-year-to-date-pages report-data)
   (fees-and-carried-interest-pages report-data)))
